import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../auth/msalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);